import React, { useEffect, useMemo, useState } from 'react';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Left from '../../components/css/Left';
import Center from '../../components/css/Center';
import Loading from '../../components/common/Loading';
import Button from '../../components/elements/Button';
import Icon from '../../components/common/Icon';
import SameLine from '../../components/css/SameLine';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fetchUserInfo } from '../../utils';
import Back from '../../components/common/Back';

const ReadinessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [readiness, setReadiness] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reload, setReload] = useState(false);


  useEffect(() => {
    fetchUserInfo('/team_readiness?own_team=1', (data) => setReadiness(data.readiness), setLoading, setError);
  }, [reload]);

  const NAV_BY_KEY = {
    captain: '/players',
    players: '/players',
    all_player_photos: '/players',
    photo: '/edit-team',
    slogan: '/edit-team',
    bio: '/edit-team',
    song: '/edit-team',
    joker: '/battles',
    challenged: '/teams',
    mission: '/missions',
    // Roles are picked on the team page, on each member's own card.
    role: null,
  };

  const checklist = useMemo(() => {
    const go = (path) => () => navigate(path);
    const pathFor = (key) => {
      if (key === 'role') {
        return readiness?.team_id ? `/public-team/${readiness.team_id}` : '/home';
      }
      return NAV_BY_KEY[key] || '/home';
    };
    return (readiness?.checks || []).map((c) => ({
      label: t(`readinesstext.${c.key}`),
      done: c.done,
      onGo: go(pathFor(c.key)),
    }));
  }, [readiness, t, navigate]);


  return (
    <Base activeNav="home">
      <Card>
        <Back />
        <div className="text-align-center">
          <Title my="2" heading="4">
              {t('yourReadinessChecklist')}
            </Title>
        </div>

        {(
          <>
            <div className="mt-3">
              {loading && <Center><Loading /></Center>}

              {!loading && readiness && (
                <Center>
                  <div
                    className="progress-circle"
                    style={{
                      background: `conic-gradient(var(--primary-color) ${readiness.readiness}%, #e9ecef 0)`,
                      cursor: 'default',
                    }}
                  >
                    <div className="progress-circle-inner">
                      <span className="readiness-text">{readiness.readiness}%</span>
                    </div>
                  </div>
                </Center>
              )}

              {!loading && !readiness && (
                <div className="text-secondary mt-2">
                  {t('somethingWentWrong')}
                </div>
              )}
            </div>

            <div className="mt-4">
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {checklist.map((item, idx) => (
                  <li
                    key={idx}
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      padding: '10px 0',
                      borderBottom: '1px solid rgba(0,0,0,0.08)',
                      fontSize: '16px',
                    }}
                  >
                    <span>
                      {item.done ? '✅' : '❌'} {item.label}
                    </span>

                    <Button
                      theme={item.done ? 'light' : 'primary'}
                      className="px-2 my-3"
                      styles={{ fontSize: '0.85rem' }}
                      onClick={item.onGo}
                      mb='3'
                    >
                      <SameLine>
                        {t('go')}
                        <Icon name="angle-right" className="ms-2" />
                      </SameLine>
                    </Button>
                  </li>

                ))}
              </ul>
            </div>

          </>
        )}

        {!!error && (
          <div className="mt-3 text-danger">
            <small>{t(error)}</small>
          </div>
        )}
      </Card>
    </Base>
  );
};

export default ReadinessPage;
